const screenXS = 480;
const screenSM = 768;
const screenMD = 979;
const screenLG = 1200;

export enum Screen {
    mobile = 'screenXS',
    tablet = 'screenSM',
    desktop = 'screenMD',
    largeDesktop = 'screenLG',
}

export const screenFrom = (screen: string): string => {
    if (screen === Screen.mobile) {
        return `@media screen and (min-width: ${screenXS}px)`;
    }
    if (screen === Screen.tablet) {
        return `@media screen and (min-width: ${screenSM}px)`;
    }
    if (screen === Screen.desktop) {
        return `@media screen and (min-width: ${screenMD}px)`;
    }
    if (screen === Screen.largeDesktop) {
        return `@media screen and (min-width: ${screenLG}px)`;
    }
    return '';
};

export const screenUpTo = (screen: string): string => {
    if (screen === Screen.mobile) {
        return `@media screen and (max-width: ${screenXS - 1}px)`;
    }
    if (screen === Screen.tablet) {
        return `@media screen and (max-width: ${screenSM - 1}px)`;
    }
    if (screen === Screen.desktop) {
        return `@media screen and (max-width: ${screenMD - 1}px)`;
    }
    if (screen === Screen.largeDesktop) {
        return `@media screen and (max-width: ${screenLG - 1}px)`;
    }
    return '';
};
